var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('category-form',{attrs:{"submit":_vm.submit,"formTitle":'Create Category',"role":"create"}})}
var staticRenderFns = []

export { render, staticRenderFns }